import type { IntlShape } from 'react-intl';

export enum BudgetStatusEnum {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  CHANGED = 'CHANGED',
  COUNTER_PROPOSAL = 'COUNTER_PROPOSAL',
}

export const BudgetStatusLabelMap: Record<BudgetStatusEnum, string> = {
  [BudgetStatusEnum.PENDING]: 'Pendente',
  [BudgetStatusEnum.APPROVED]: 'Aprovado',
  [BudgetStatusEnum.REJECTED]: 'Recusado',
  [BudgetStatusEnum.CHANGED]: 'Alterado',
  [BudgetStatusEnum.COUNTER_PROPOSAL]: 'Contraproposta',
};

export const getBudgetStatusLabel = (status: BudgetStatusEnum | string): string => {
  if (status in BudgetStatusLabelMap) {
    return BudgetStatusLabelMap[status as BudgetStatusEnum];
  }
  return status;
};

export const BudgetStatusFilterMap: Record<string, BudgetStatusEnum> = {
  Pendente: BudgetStatusEnum.PENDING,
  Aprovado: BudgetStatusEnum.APPROVED,
  Recusado: BudgetStatusEnum.REJECTED,
  Alterado: BudgetStatusEnum.CHANGED,
  Contraproposta: BudgetStatusEnum.COUNTER_PROPOSAL,
};

export const getBudgetStatusFilter = (label: string): BudgetStatusEnum => {
  if (label in BudgetStatusFilterMap) {
    return BudgetStatusFilterMap[label];
  }
  return BudgetStatusFilterMap.PENDING;
};

export enum BudgetStatusFilterEnum {
  SENT = "Enviado",
  UPDATED = "Alterado",
  COUNTER_PROPOSED = "Contraproposta",
  PENDING = "Pendente",
  APPROVED = "Aprovado",
  APPROVED_BY_FACTORY = "Aprovado pela fábrica",
  REJECTED = "Recusado",
}

export const BudgetStatusLabelIdMap: Record<BudgetStatusEnum, string> = {
  [BudgetStatusEnum.PENDING]: 'intl-msg:budgets.shared.status.pending',
  [BudgetStatusEnum.APPROVED]: 'intl-msg:budgets.shared.status.approved',
  [BudgetStatusEnum.REJECTED]: 'intl-msg:budgets.shared.status.rejected',
  [BudgetStatusEnum.CHANGED]: 'intl-msg:budgets.shared.status.changed',
  [BudgetStatusEnum.COUNTER_PROPOSAL]: 'intl-msg:budgets.shared.status.counterProposal',
};

export const BudgetStatusValueLabelIdMap: Record<string, string> = {
  pendente: 'intl-msg:budgets.shared.status.pending',
  aprovado: 'intl-msg:budgets.shared.status.approved',
  recusado: 'intl-msg:budgets.shared.status.rejected',
  alterado: 'intl-msg:budgets.shared.status.changed',
  contraproposta: 'intl-msg:budgets.shared.status.counterProposal',
  enviado: 'intl-msg:budgets.shared.status.sent',
  'aprovado pela fábrica': 'intl-msg:budgets.shared.status.approvedByFactory',
  'concluído': 'intl-msg:budgets.shared.status.completed',
  criado: 'intl-msg:budgets.shared.status.created',
  pending: 'intl-msg:budgets.shared.status.pending',
  approved: 'intl-msg:budgets.shared.status.approved',
  rejected: 'intl-msg:budgets.shared.status.rejected',
  changed: 'intl-msg:budgets.shared.status.changed',
  updated: 'intl-msg:budgets.shared.status.changed',
  counter_proposal: 'intl-msg:budgets.shared.status.counterProposal',
  counter_proposed: 'intl-msg:budgets.shared.status.counterProposal',
  sent: 'intl-msg:budgets.shared.status.sent',
  approved_by_factory: 'intl-msg:budgets.shared.status.approvedByFactory',
  completed: 'intl-msg:budgets.shared.status.completed',
  created: 'intl-msg:budgets.shared.status.created',
};

export const getBudgetStatusLabelId = (status: BudgetStatusEnum | string): string | undefined => {
  if (!status) {
    return undefined;
  }
  if (status in BudgetStatusLabelIdMap) {
    return BudgetStatusLabelIdMap[status as BudgetStatusEnum];
  }
  const normalized = String(status).trim().toLowerCase();
  return Object.prototype.hasOwnProperty.call(BudgetStatusValueLabelIdMap, normalized)
    ? BudgetStatusValueLabelIdMap[normalized]
    : undefined;
};

export const translateBudgetStatus = (intl: IntlShape, status: BudgetStatusEnum | string): string => {
  const id = getBudgetStatusLabelId(status);
  return id ? intl.formatMessage({ id }) : getBudgetStatusLabel(status);
};
